import { computed } from 'vue'

export async function useShowCategoryInsteadOfSource() {
  const route = useRoute()
  const { client } = await useOpenFeature()

  return computed(() => {
    const isHomepageRoute =
      route.path === '/' || String(route.name ?? '').startsWith('index')
    if (!isHomepageRoute) return false
    return client.getBooleanValue('showCategoryInsteadOfSource', false)
  })
}
